/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function MusicNotesSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M212.92285,25.69434a7.99949,7.99949,0,0,0-6.86328-1.45557l-128,32A7.99964,7.99964,0,0,0,72,64V174.0835A35.98908,35.98908,0,1,0,88,204V70.24609l112-28V142.0835A35.98908,35.98908,0,1,0,216,172V32A7.99874,7.99874,0,0,0,212.92285,25.69434Z" />
    </Svg>
  );
}

export default MusicNotesSimple;
